import * as React from "react";
import { IStore } from "reducers";
import { connect } from "react-redux";
import { IReduxProps, IOwnProps } from "./pinned-row-constants";
import { withRouter, RouterState } from "react-router";
import { TotalsRollupRenderer } from "./totals";
import { PlanMetricRenderer } from "./plan";
import { getReviewPlanFromState } from "reducers/selectors/collection";
import { getGridParamsFromLocation } from "components/product-collection/product-collection";
import { getDimensionFilters } from "helpers/door-collection";
import { getTotal, getPlan } from "./pinned-row-helpers";

const PinnedRowRenderer: React.FunctionComponent<IReduxProps & IOwnProps & RouterState> = (props) => {
    const { displayPlanMetrics, displayTotals } = props;

    if (displayPlanMetrics) {
        return <PlanMetricRenderer {...props} />;
    } else if (displayTotals) {
        return <TotalsRollupRenderer {...props} />;
    } else {
        return <div />;
    }
};

const mapStateToProps = (state: IStore, ownProps) => {
    const { params, location, data, colDef, doorId, groupId, classificationName, classificationValue, doors } =
        ownProps;
    const { poi, showTotals } = location.query;
    const capabilities = state.collection?.driveItem?.capabilities;
    const accessPlan = capabilities?.collection_capabilities?.can_edit_plan || false;
    const displayPlanMetrics = accessPlan && data.planType;
    const displayTotals = showTotals && !displayPlanMetrics;
    const { reviewPlan } = getReviewPlanFromState(state, params.id, poi);
    const dimensionFilters = getDimensionFilters(getGridParamsFromLocation(location));
    const totalType = data.totalType;
    const total = getTotal({
        colType: colDef.type,
        doorId,
        groupId,
        classificationName,
        classificationValue,
        doorTotals: state.collection.doorTotals,
        totalType,
    });
    const plan = getPlan({
        colType: colDef.type,
        doorId,
        groupId,
        classificationName,
        classificationValue,
        reviewPlan,
        doorTotals: state.collection.doorTotals,
        totalType,
        dimensionFilters,
        doors,
    });
    return {
        displayPlanMetrics,
        displayTotals,
        total,
        plan,
        reviewPlan,
        dimensionFilters,
        totalType,
    };
};

export const PinnedRowRendererContainer = withRouter(
    connect<IReduxProps, {}, IOwnProps>(mapStateToProps)(PinnedRowRenderer),
);

export { PinnedRowRenderer };
